import styled from 'styled-components';
import React, { ReactNode } from 'react';

import {
  Nullable,
} from '@/core/interfaces/common';

export const SignatureArea = styled.div`
  width: 100%;
  padding-top: 20px;
`;

interface AdvocateSignatureProps {
  firstName: Nullable<string>;
  lastName: Nullable<string>;
  mode: Nullable<string>;
  streetAddress: string;
  zipCode: string;
  Wrapper?: React.ComponentType<{ children: ReactNode }>;
}

export const AdvocateSignature = ({
  firstName,
  lastName,
  mode = null,
  streetAddress = '',
  zipCode = '',
  Wrapper = SignatureArea,
}: AdvocateSignatureProps) => (
  <Wrapper>
    <p>{mode === 'petition' ? 'As signed by:' : 'Sincerely,'}</p>
    {firstName || lastName ?
      (
        <p>{`${firstName} ${lastName}`}</p>) :
        <p>[Your name here]</p>
    }
    {
      streetAddress.trim() && zipCode.trim().length >= 5 ?
        (<p>{`${streetAddress.trim()}, ${zipCode.trim()}`}</p>) :
        ''
    }
  </Wrapper>
);
